import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { CARD_DIAGNOSTICS_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { CARD_DIAGNOSTICS_REPORT } from "../interfaces/dashboard";

export default function CardDiagnostics() {
    const cardDiagnosticsReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.CARD_DIAGNOSTICS_REPORT;

    const [cardDiagnosticsReportTableData, setCardDiagnosticsReportTableData] = useState<CARD_DIAGNOSTICS_REPORT[]>([]);

    useEffect(() => {
        setCardDiagnosticsReportTableData(CARD_DIAGNOSTICS_REPORT_DATA)
    }, []);

    return (
        <Reports
            reportType="CARD_DIAGNOSTICS"
            tableColumns={cardDiagnosticsReportTableColumns}
            tableData={cardDiagnosticsReportTableData} />
    );
}